import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [{
    path: '/',
    name: 'Index',
    component: () => import( /* webpackChunkName: "about" */ '../views/Index.vue')
  },
  {
    path: '/Login',
    name: 'Login',
    component: () => import( /* webpackChunkName: "about" */ '../views/Login.vue')
  },
  {
    path: '/Services',
    name: 'Services',
    component: () => import( /* webpackChunkName: "about" */ '../views/Services.vue')
  },
  {
    path: '/Cases',
    name: 'Cases',
    component: () => import( /* webpackChunkName: "about" */ '../views/Cases.vue')
  },
  {
    path: '/News',
    name: 'News',
    component: () => import( /* webpackChunkName: "about" */ '../views/News.vue')
  },
  {
    path: '/Edit',
    name: 'Edit',
    component: () => import( /* webpackChunkName: "about" */ '../views/Edit.vue')
  },
  {
    path: '/Manager',
    name: 'Manager',
    component: () => import( /* webpackChunkName: "about" */ '../views/Manager.vue')
  },
  {
    path: '/AllCases',
    name: 'AllCases',
    component: () => import( /* webpackChunkName: "about" */ '../views/AllCases.vue')
  },
];

const router = new VueRouter({
  routes,
  // 可以去掉地址栏带有的/#/ 但需要和vue.config.js一起配置
  // mode: 'history',
});


export default router;